import { prop } from 'lodash/fp'
import { useTranslation } from 'react-i18next'

import { useOptimizationGroupsQuery } from '@/entities/optimization-group'
import { usePricingCampaignsQuery } from '@/entities/pricing-campaign'

type CheckoutProps = {
	formData: {
		campaigns: string[]
		groups: string[]
	}
}
function selectItemsIn<T = unknown>(selcted: string[]) {
	return (data: T[]): string[] =>
		data.filter(({ id }: any) => selcted.includes(id)).map(prop('name'))
}

function Checkout({ formData }: CheckoutProps) {
	const { t } = useTranslation()

	const selectedCampaigns = formData.campaigns
	const selectedGroups = formData.groups
	const pricingCampaignsQuery = usePricingCampaignsQuery<string[]>(
		{},
		{
			select: selectItemsIn(selectedCampaigns),
		}
	)
	const optimizationGroupsQuery = useOptimizationGroupsQuery<string[]>({
		select: selectItemsIn(selectedGroups),
	})

	return (
		<div className='grid grid-cols-2 gap-4'>
			<div className='flex flex-col gap-2'>
				<h4>{t('pc.reassign.want_to_reassign')}</h4>
				<ul className='max-h-[60vh] min-h-96 list-inside list-disc overflow-y-scroll'>
					{pricingCampaignsQuery.data?.map((name) => (
						<li className='text-sm text-muted-foreground' key={name}>
							{name || 'None'}
						</li>
					))}
				</ul>
			</div>
			<div className='flex flex-col gap-2'>
				<h4>{t('pc.copy.to_following_ogs')}:</h4>
				<ul className='max-h-[60vh] min-h-96 list-inside list-disc overflow-y-scroll'>
					{optimizationGroupsQuery.data?.map((name) => (
						<li className='text-sm text-muted-foreground' key={name}>
							{name || 'None'}
						</li>
					))}
				</ul>
			</div>
		</div>
	)
}

export default Checkout
